import React from "react";
import { useQuery } from '@tanstack/react-query';
import { AdminPanelPage } from "../AdminPanelPage";
import { useLocalizedStrings } from "../../Localization";
import { AuditLogsDataTable } from "./components/AuditLogsDataTable";
import { useUserAllowed } from "../../Components/PermissionsUtil";
import { usePost } from "../../API";

export const AuditLogsPage = () => {
  const L = useLocalizedStrings();
  const isAdmin = useUserAllowed(["admin"]);

  // Fetch page configuration from the API
  const fetchPageConfig = usePost('/api/admin_panel/page_config');

  const { data: pageConfigResponse, isLoading: isConfigLoading } = useQuery({
    queryKey: ['adminPanelPageConfig', 'Audit Logs'],
    queryFn: async () => {
      const response = await fetchPageConfig({
        kind: 'Audit Logs'
      });
      return response;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  });

  // Extract config from response
  const pageConfig = pageConfigResponse?.data?.config;

  return (
    <AdminPanelPage
      title={L.admin_panel.nav.audit_logs}
      description={L.admin_panel.audit_logs.description}
      breadcrumbs={[
        {
          label: L.admin_panel.nav.audit_logs,
        },
      ]}
    >
      {isAdmin ? (
        <AuditLogsDataTable
          pageConfig={pageConfig}
          isConfigLoading={isConfigLoading}
        />
      ) : null}
    </AdminPanelPage>
  );
};
